export default __webpack_public_path__ + "static/media/basement-reverse.6d900194.mp4";